import React, { useRef, useState } from "react";
import config from "lib/fr-config";
import CommonSplitView from "presentational/common/CommonSplitView";
import OutfitImageView from "presentational/common/OutfitImageView";
import NameTagView from "presentational/outfitDetail/NameTagView";
import OutfitDetailItemView from "presentational/outfitDetail/OutfitDetailItemView";
import OutfitDetailMemoView from "presentational/outfitDetail/OutfitDetailMemoView";
import WrongPathErrorView from "presentational/error/WrongPathErrorView";
import ItemModalView from "presentational/common/modals/ItemModalView";
import OptBtnForMyOutfitModalView from "presentational/outfitDetail/OptBtnForMyOutfitModalView";
import OptBtnForOthersOutfitModalView from "presentational/outfitDetail/OptBtnForOthersOutfitModalView";
import ImageOnlyModalView from "presentational/common/modals/ImageOnlyModalView";
import { getImgUrl } from "lib/imageUrlHelper";
import PropTypes from "prop-types";

const IMAGE_RATIO = config.outfitImage.RATIO;

OutfitDetailPanelXLView.propTypes = {
  outfitHash: PropTypes.string.isRequired,
  onEditModeSelect: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  infoData: PropTypes.shape({
    ownerName: PropTypes.string,
    profileImage: PropTypes.string,
    outfitImage: PropTypes.string,
    gender: PropTypes.string,
    userLocation: PropTypes.string
  }).isRequired,
  itemData: PropTypes.array,
  calendarData: PropTypes.object,
  memoData: PropTypes.object,
  bookmarkData: PropTypes.object,
  pickData: PropTypes.object,
  isWrongHash: PropTypes.bool.isRequired,
  bookmarkFolderList: PropTypes.array.isRequired,
  pickFolderList: PropTypes.array.isRequired,
  typeOfUser: PropTypes.oneOf(["pending", "owner", "others", "guest"])
    .isRequired,
  onBookmarkChange: PropTypes.func.isRequired,
  onPickChange: PropTypes.func.isRequired,
  onBookmarkFolderCreateBtnSubmit: PropTypes.func.isRequired,
  onPickFolderCreateBtnSubmit: PropTypes.func.isRequired,
  onBookmarkFolderListRequest: PropTypes.func.isRequired,
  onPickFolderListRequest: PropTypes.func.isRequired,
  onOwnersItemClick: PropTypes.func.isRequired,
  onMemoSubmitClick: PropTypes.func.isRequired,
  onLogInRecommendationButtonClick: PropTypes.func.isRequired
};

function OutfitDetailPanelXLView(props) {
  const {
    outfitHash,
    onEditModeSelect,
    onDeleteClick,
    infoData,
    itemData,
    calendarData,
    memoData,
    bookmarkData,
    pickData,
    isWrongHash,
    bookmarkFolderList,
    pickFolderList,
    typeOfUser,
    onBookmarkChange,
    onPickChange,
    onBookmarkFolderCreateBtnSubmit,
    onPickFolderCreateBtnSubmit,
    onBookmarkFolderListRequest,
    onPickFolderListRequest,
    onOwnersItemClick,
    onMemoSubmitClick,
    onLogInRecommendationButtonClick
  } = props;
  const [mainImageModalOpen, setMainImageModalOpen] = useState(false);
  const [itemModalOpen, setItemModalOpen] = useState(false);
  const [optionModalOpen, setOptionModalOpen] = useState(false);
  const [itemInfo, setItemInfo] = useState(null);

  const nameTagWrapper = useRef();

  const getWidthOfLeftSide = fixedHeightValue => {
    if (!nameTagWrapper) return null;
    const heightOfNametag = nameTagWrapper.current.clientHeight;
    const heightOfViewportWithoutImage = fixedHeightValue + heightOfNametag;
    const viewportHeight = window.innerHeight;
    const imageHeight = viewportHeight - heightOfViewportWithoutImage;
    return imageHeight * IMAGE_RATIO;
  };

  const isEditModeEnabled = () => {
    return !!itemData && !!calendarData;
  };

  const handleLogInRecommendationButtonClick =
    ({ type, loc }) =>
    () => {
      onLogInRecommendationButtonClick({ type, loc });
    };

  const handleItemClick = itemInfo => {
    if (typeOfUser === "owner") {
      onOwnersItemClick(itemInfo);
    } else {
      setItemModalOpen(true);
      setItemInfo(itemInfo);
    }
  };

  const handleMoreIconClick = () => {
    setOptionModalOpen(true);
  };

  const handleMainImageClick = () => {
    setMainImageModalOpen(true);
  };

  const handleModalClose = () => {
    setMainImageModalOpen(false);
    setItemModalOpen(false);
    setOptionModalOpen(false);
  };

  const HandleMemoSubmit = ({ who, where, what, etc }) => {
    onMemoSubmitClick({ who, where, what, etc });
  };

  const getLeftSide = () => {
    const imageSrc = getImgUrl("outfit", infoData.outfitImage);

    return (
      <div>
        <div onClick={handleMainImageClick}>
          <OutfitImageView imageSrc={imageSrc} increaseZIndex />
        </div>
        <div ref={nameTagWrapper}>
          <NameTagView
            info={infoData}
            typeOfUser={typeOfUser}
            calendarData={calendarData}
            bookmarkData={bookmarkData}
            bookmarkFolderList={bookmarkFolderList}
            pickData={pickData}
            pickFolderList={pickFolderList}
            onBookmarkChange={onBookmarkChange}
            onPickChange={onPickChange}
            onBookmarkFolderCreateBtnSubmit={onBookmarkFolderCreateBtnSubmit}
            onPickFolderCreateBtnSubmit={onPickFolderCreateBtnSubmit}
            onBookmarkFolderListRequest={onBookmarkFolderListRequest}
            onPickFolderListRequest={onPickFolderListRequest}
            onMoreBtnClick={handleMoreIconClick}
          />
        </div>
        {infoData.outfitImage && (
          <ImageOnlyModalView
            open={mainImageModalOpen}
            imageRatio={IMAGE_RATIO}
            imageSrc={imageSrc}
            onClose={handleModalClose}
          />
        )}
      </div>
    );
  };

  const getRightSide = () => {
    return (
      <div>
        <OutfitDetailMemoView
          memoData={memoData}
          typeOfUser={typeOfUser}
          onMemoSubmit={HandleMemoSubmit}
        />
        {typeOfUser !== "pending" && (
          <OutfitDetailItemView
            itemData={itemData}
            typeOfUser={typeOfUser}
            onItemClick={handleItemClick}
            onEditModeSelect={onEditModeSelect}
            onLogInRecommendationButtonClick={
              handleLogInRecommendationButtonClick
            }
          />
        )}
      </div>
    );
  };

  const render = () => {
    if (isWrongHash) {
      return <WrongPathErrorView />;
    } else {
      return (
        <div>
          <CommonSplitView
            getWidthOfLeftSide={getWidthOfLeftSide}
            leftSideComponent={getLeftSide()}
            rightSideComponent={getRightSide()}
          />
          {itemInfo && (
            <ItemModalView
              open={itemModalOpen}
              itemInfo={itemInfo}
              onClose={handleModalClose}
              guestMode={typeOfUser === "guest"}
              displayDetailTooltip
            />
          )}
          {typeOfUser === "owner" && (
            <OptBtnForMyOutfitModalView
              outfitHash={outfitHash}
              optionModalOpen={optionModalOpen}
              onEditModeSelect={onEditModeSelect}
              isEditModeEnabled={isEditModeEnabled()}
              outfitImgUrl={getImgUrl("outfit", infoData.outfitImage)}
              onClose={handleModalClose}
              onDeleteClick={onDeleteClick}
              username={infoData.ownerName}
              itemData={itemData}
              calendarData={calendarData}
            />
          )}
          {typeOfUser === "others" && (
            <OptBtnForOthersOutfitModalView
              optionModalOpen={optionModalOpen}
              onClose={handleModalClose}
            />
          )}
        </div>
      );
    }
  };

  return render();
}

export default OutfitDetailPanelXLView;
